import $ from 'jquery';
import slick from 'slick-slider';
import lightbox from './lightbox';
import sliders from './sliders';

$(function() {

    var portfolio = $('.portfolio');
    if(!portfolio.length) return;


    var map = portfolio.find('.portfolio__map');
    var list = portfolio.find('.portfolio__list');
    var svg = map.find('svg');
    var svgWrap = svg.closest('.svg-wrap');
    var width = parseInt(svg.attr('width'));
    var ratio = svg.outerWidth() / width;
    var activeCountry = null;
    var countries = map.data('countries');
    var select = portfolio.find('.portfolio__select select');
    var modal = $('.lightbox-modal');
    var highlight = map.data('highlight');

    $(window).on('resize',function() {
        ratio = svg.outerWidth() / width;
    });

    for(var code in countries) {
        var name = countries[code];
        var path = svg.find(`#countries path#${code}`);
        if(highlight) {
            path.addClass('has-projects');
        }
        path.hover(function(e) {
            $(this).toggleClass('active',e.type == "mouseenter");
            if(e.type == "mouseenter") {
                showCountryLabel( this.id, true );
            } else {
                showCountryLabel();
            }
        });
        path.on('click',function() {
            var code = this.id;
            var el =  slider.find(`.slick-slide:not(.slick-cloned) [data-country="${code}"]`);
            var i = el.closest('.slick-slide').data('slick-index');
            var c = slider.slick('slickCurrentSlide');
            if(c!=i) {
                slider.slick('slickGoTo',i);
            }
        })
    }

    list.find('a[data-country]').hover(function(e) {
        var code = $(this).data('country');
        var path = svg.find( `[data-id="${code}"]` );
        path.toggleClass('active',e.type == "mouseenter");
        if(e.type == "mouseenter") {
            showCountryLabel(code);
        } else {
            showCountryLabel();
        }
    });
    list.on('click','a[data-id]',function() {
        var id = $(this).data('id');
        activateProject(id);
    });

    var slider = portfolio.find('[data-portfolio-slider]');
    var sliderWrap = slider.parent();
    var sliderNav = sliderWrap.find('.portfolio__slider__nav');

    function afterSlideChange(currentSlide) {
        var slide = slider.find('.slick-current');
        var country = slide.find('[data-country]').data('country');
        var id = slide.find('[data-id]').data('id');
        select.val(country);
        activateCountry(country);
        activateProject(id);
    }

    function clampTexts() {
        slider.find('.post-content p').each(function() {
            var more = $(this).find('span.more');
            $(this).contents().each(function() {
                if(this.nodeType == Node.TEXT_NODE) {
                    var t = this.nodeValue.split(" ");
                    t.forEach( word => {
                        if(!word)return;
                        $("<span>").addClass('word').text(word + ' ').insertBefore($(this));
                    } );
                    $(this).remove();
                }
            });
            $(this).removeClass('clamped').find('.word').show();

            if(this.scrollHeight > this.offsetHeight) {
                $(this).addClass('clamped');
                var h = $(this).outerHeight();
                var w = $(this).outerWidth();
                var clamp = false;
                var moreWidth = more.outerWidth();

                $(this).find('.word').each(function() {
                    if(clamp) {
                        $(this).hide();
                        return;
                    }
                    var line = Math.floor( this.offsetTop / this.offsetHeight );
                    if( line == 2 ) {
                        if(this.offsetLeft + this.offsetWidth > w - moreWidth ) {
                            clamp = true;
                            $(this).hide();
                        }
                    }
                });

            }
        });
    }

    slider.on('afterChange',function(event,slick,currentSlide) {
        afterSlideChange( currentSlide );
    });

    sliders.initPreload( slider, 2 );

    slider.on('init',function() {

        slider.initImages();
        setTimeout(function() {
            clampTexts();
            afterSlideChange( slider.slick('slickCurrentSlide') );
        },100);
    });
    var clampTimer;
    $(window).on('resize',function() {
        if(clampTimer)clearTimeout(clampTimer);
        clampTimer = setTimeout(function() {
            clampTexts();
        },100);
    });

    slider.slick({
        slidesToShow: 1,
        infinite: true,
        slidesToScroll: 1,
        swipeToSlide: true,
        lazyLoad: false,
        dots: false,
        arrows: false,
        adaptiveHeight: false,
        appendArrows: sliderWrap.find('.portfolio__slider__arrows'),
        nextArrow: "<span class='compact'><i class='fas fa-arrow-right'></i></span>",
        prevArrow: "<span class='compact'><i class='fas fa-arrow-left'></i></span>",
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    variableWidth: true,
                    centerMode: true,
                }
            },
            {
                breakpoint: 359,
                settings: {
                    arrows: true,
                    centerMode: false,
                }
            },
        ]
    });

    sliderNav.on('click','a',function(e) {
        var rel = $(this).attr('rel');
        slider.slick( rel == "prev" ? "slickPrev" : 'slickNext');
    });

    select.on('change',function(event) {
        var code = $(this).val();
        //navigate to first project
        var el =  slider.find(`.slick-slide:not(.slick-cloned) [data-country="${code}"]`);
        var i = el.closest('.slick-slide').data('slick-index');
        var c = slider.slick('slickCurrentSlide');
        if(c!=i) {
            slider.slick('slickGoTo',i);
        }
    });

    function activateCountry(code) {
        svg.find('path.current').removeClass('current');
        var path = svg.find( `#countries path#${code}` );
        path.addClass('current');
        activeCountry = code;
    }

    function activateProject(id) {
        var i = slider.find(`.slick-slide:not(.slick-cloned) [data-id="${id}"]`).closest('.slick-slide').data('slick-index');
        slider.slick('slickGoTo',i);
        list.find('a.active').removeClass('active');
        list.find(`a[data-id="${id}"]`).addClass('active');
    }

    function showCountryLabel(code,highlight) {
        svgWrap.find('> label').remove();
        list.find('a').removeClass('highlight');
        if(code) {
            var path = svg.find( `#countries path#${code}` );
            var name = countries[code];
            var size = path.get(0).getBoundingClientRect();
            var label = $('<label>').html(name).appendTo(svgWrap);
            var mapSize = svg.get(0).getBoundingClientRect();
            label.css({left: size.left - mapSize.left + size.width * 0.5,top:size.top - mapSize.top + size.height});
            if(highlight) list.find(`a[data-country="${code}"]`).addClass('highlight');
        }

    }

    if(map.data('country')) {
        activateCountry(map.data('country'));
    }

    if(modal.length) {
        $(document).on('click','.portfolio__card__image',function() {
            var start = $(this).closest('[data-start]').data('start');
            lightbox.open(modal,start);
        });
        // var triggers = portfolio.find('.portfolio__card__image');
        // lightbox.init({
        //     triggers: triggers,
        //     modal: modal,
        //     getIndex: function(trigger) {
        //         var start = trigger.closest('[data-id]').data('start');
        //         return start;
        //     }
        // });
    }

});
